(() => {
  const returnFilterFocus = () => {
    const drawerId = document.documentElement.getAttribute('data-wubs-filters-open');
    if (!drawerId) return;
    const trigger = [...document.querySelectorAll('[data-wubs-open-filters][aria-expanded="true"]')]
      .find(button => button.getAttribute('aria-controls') === drawerId);
    if (!trigger) return;
    requestAnimationFrame(() => {
      if (trigger.isConnected && trigger.getAttribute('aria-expanded') === 'false') {
        trigger.focus({ preventScroll: true });
      }
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') returnFilterFocus();
  }, true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('[data-wubs-close-filters], [data-wubs-filters-backdrop]')) {
      returnFilterFocus();
    }
  }, true);
})();
